export const DEFAULT_THEME_ID = 'crisp';

export const THEME_OPTIONS = [
  {
    id: 'crisp',
    label: 'Crisp',
    description: 'Bright daytime workspace with clean contrast and green-forward accents.',
    swatches: ['#f7faf8', '#ffffff', '#2fad50', '#14231b', '#2b6cc8', '#6f45c1'],
  },
  {
    id: 'deep',
    label: 'Deep',
    description: 'Dark, high-contrast workspace inspired by your custom accent palette.',
    swatches: ['#272822', '#1d1e19', '#a6e22e', '#fdfff1', '#66d9ef', '#ae81ff'],
  },
];

export const THEME_OPTION_IDS = new Set(THEME_OPTIONS.map((theme) => theme.id));
